import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { ToastCloseButton } from './ToastCloseButton';

type Props = Partial<ToastContainerProps>;

/** Toast container with app defaults: custom close button, position, and styles. */
export const NotificationsContainer = (p: Props) => {
  return (
    <ToastContainer
      closeButton={ToastCloseButton}
      style={{
        minHeight: '3rem',
        width: '360px',
      }}
      toastStyle={{
        boxShadow:
          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05)',
      }}
      progressStyle={{ height: '3px', opacity: 0.5 }}
      key="toast-container"
      autoClose={4000}
      position="bottom-right"
      theme={'light'}
      {...p}
    />
  );
};
